import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import { useParams, withRouter } from 'react-router';
import UserGroupEditService from '../service/UserGroupEditService';

const config = data => {
	return {
		key: 'userGroupEditForm',
		topic: 'userGroup',
		service: UserGroupEditService,
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true,
					readOnly: data.id !== 'new'
				}
			];

			return fields;
		}
	};
};

function UserGroupEditForm() {
	const { id } = useParams();
	const myConfig = config({ id });
	return (
		<EditFormPage config={myConfig} />
	);
}

export default withRouter(UserGroupEditForm);